import { Component, OnInit, ChangeDetectorRef } from "@angular/core";
import { SieniService } from "src/app/shared/services/sieni.service";
import { TranslateService } from "@ngx-translate/core";
import { MOrganization } from "src/app/shared/models/organization.model";
import { MModuleEvaluation } from "src/app/shared/models/module-evaluation.model";
import { MEvaluation } from "src/app/shared/models/evaluation.model";
import { ActivatedRoute, Router } from "@angular/router";
import { MChapterData } from "src/app/shared/models/chapter-data.model";
import { MProcess } from "src/app/shared/models/process.model";
import { DatePipe } from "@angular/common";
import * as moment from "moment";
import {
  Breadcrumb,
  Evidence,
  EvaluationFormData,
  EvaluationEvidence,
} from "src/app/shared/interfaces/Organization";
import { MResultType } from "src/app/shared/models/result-type.model";
import { Alert } from "src/app/shared/models/alert.model";
import { MRequirement } from "src/app/shared/models/requirement.model";
import { MRequirementEvaluation } from "src/app/shared/models/requirement-evaluation.model";
import { MEvaluationEvidence } from "src/app/shared/models/evaluation-evidence.model";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { environment } from "src/environments/environment";
import { Subject } from "rxjs";
import { takeUntil, map } from "rxjs/operators";
import { EvaluationDataIdService } from "src/app/shared/services/evaluation-data-id.service";
import { MReportType } from "src/app/shared/models/report-type.model";
import { async } from "q";
import { getBodyHelp } from "./dataHelpBodyHtml";

@Component({
  selector: "app-requirement-evaluation",
  templateUrl: "./requirement-evaluation.component.html",
  styleUrls: ["./requirement-evaluation.component.scss"],
  providers: [DatePipe],
})
export class RequirementEvaluationComponent implements OnInit {
  public org: MOrganization = null;
  public evaluation: MEvaluation = null;
  public evaluationInfo: MModuleEvaluation = null;

  public filteredRequirements: MRequirement[] = null;
  public selectedProcess: number = 0;
  public selectedRequirement: MRequirement = null;

  public moduleId: number = null;
  public versionId: number = null;
  public chapterId: number = null;
  public indexId: number = null;
  public itemId: number = null;
  public crumbs: Breadcrumb[] = [];
  public numbers: string[] = [];
  public desc1: string = null;
  public desc2: string = null;
  public data: EvaluationFormData[] = [];
  public dataIndex: number = 0;
  public isEvaluating: boolean = false;
  public updatingFiles: boolean = false;
  public envImage: string = null;
  public reloading: boolean = false;
  public reportTypes: MReportType[] = [];
  public reportUrl: string = "";
  public gettingReport: boolean = false;
  protected ngUnsubscribe: Subject<void> = new Subject<void>();
  public userData;
  public hash: string = "";
  public isRequired: boolean = false;
  public type1: boolean = false;
  public type2: boolean = false;
  public type3: boolean = false;
  public type4: boolean = false;
  public type5: boolean = false;

  /* Variables utiles */
  public resultTypes: MResultType[] = [];
  public processes: MProcess[] = [];
  public requirements: MRequirement[] = [];
  constructor(
    private sieniService: SieniService,
    private translate: TranslateService,
    private actvRoute: ActivatedRoute,
    private modalService: NgbModal,
    private idService: EvaluationDataIdService,
    public datePipe: DatePipe
  ) {
    /* Obtengo las parametros de la ruta */
    const paramsRoute = this.actvRoute.snapshot.params;
    this.moduleId = +paramsRoute.module_id;
    this.versionId = +paramsRoute.version_id;
    this.chapterId = +paramsRoute.chapter_id;
    this.indexId = +paramsRoute.index_id;
    this.itemId = +paramsRoute.item_id;
    /* Ruta de Enviroment para las imagenes */
    this.envImage = environment.imgUrl;
    this.initValuesVariables();
  }

  async ngOnInit() {
    this.translate.setDefaultLang("es");
    this.translate.use(this.sieniService.user.language.code);

    const [
      organization,
      process,
      resultTypes,
      startEvaluation,
    ] = await Promise.all([
      this.sieniService.getCurrentOrganization(),
      this.sieniService.getCurrentProcesses(),
      this.sieniService.getResultTypes().toPromise<any>(),
      this.sieniService.startEvaluation(this.versionId).toPromise<any>(),
    ]);

    this.org = organization;
    this.processes = process;
    console.log(resultTypes);
    this.resultTypes =
      resultTypes.data && resultTypes.data.length > 0
        ? resultTypes.data.map((type) => new MResultType(type))
        : [];

    console.log(this.resultTypes);

    this.evaluation = new MEvaluation(startEvaluation.data);
    // console.log(startEvaluation.data);
    this.idService.setEvaluation(this.evaluation);
    // console.log(this.evaluation);
    this.getPreviousEvaluations();
  }

  private initValuesVariables() {
    this.crumbs = [];
    this.requirements = null;
    this.evaluation = null;
    this.evaluationInfo = null;
    this.selectedProcess = 0;
    this.isEvaluating = false;
    this.reloading = false;
    this.updatingFiles = false;
    this.dataIndex = 0;
    this.data = [];
    this.numbers = [];
    this.selectedRequirement = null;
    this.filteredRequirements = null;
    this.desc1 = null;
    this.desc2 = null;
    this.isRequired = false;
  }

  public getPreviousEvaluations() {
    if (this.evaluation.type === "N") {
      this.getEvaluationStructure();
    } else {
      this.sieniService
        .getEvaluationByVersionId(this.versionId)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(({ data }: any) => {
          console.log(data);
          // console.log(new MModuleEvaluation(data[0]))
          for (let i = 0; i < data.length; i++) {
            if (data[i].subversion_modulo.version_modulo.existe_evaluacion) {
              this.evaluationInfo = new MModuleEvaluation(data[i]);
              this.idService.setEvaluationInfo(this.evaluationInfo);
              this.getData();
              console.log("Ev Info", this.evaluationInfo);
              this.evaluationInfo.finishDate = moment
                .utc(this.evaluationInfo.finishDate, "DD/MM/YYYY HH:mm:ss")
                .local()
                .format("DD/MM/YYYY HH:mm:ss");
              break;
            }
          }
        });
    }
  }

  public setRequirement(requirement: MRequirement, next: boolean = false) {
    console.log('>>>>SET',requirement)
    // debugger
    if (this.selectedRequirement) {
      if (
        !this.validateRequirementAplicability() &&
        !this.validateRequirementConformity()
      ) {
        if (this.data[this.dataIndex].changed && this.data[this.dataIndex].files.length > 0 ){
          Alert.buildErrorAlert(
            this.translate.instant("evaluations.requirement.filesChanged", {
              number: this.selectedRequirement.data.chapter.number,
            })
          );
          return;
        }
        if (requirement) {
          if (
            this.selectedRequirement.data.chapter.id !==
            requirement.data.chapter.id
          ) {
            this.automaticUpdate();
          }
        } else {
          this.automaticUpdate();
        }
      }
    }

    /* Otro proceso */
    if (requirement) {
      // const backStateRequirementeSelected: MRequirement = this.selectedRequirement
      this.selectedRequirement = requirement;
      /* Preguntar si tiene algun requerimiento */
      if (
        this.validateRequirementAplicability() ||
        this.validateRequirementConformity()
      ) {
        this.isRequired = true;
      } else {
        this.isRequired = false;
      }

      /* Se averigua la posicion del form data de item seleccionado */
      for (let i = 0; i < this.data.length; i++) {
        if (this.data[i].id === this.selectedRequirement.data.chapter.id) {
          this.dataIndex = i;
          break;
        }
      }
      /* Se settea la descripcion dependiento del tipo de dependecia */
      /* Deberia de aparecer el mensaje de la descricpion solo si el padre tiene la dependencia de 2 o 5 y esta activa */
      if (this.data[this.dataIndex].type) {
        this.setDescriptionTitles(this.data[this.dataIndex].type.toString());
      }
    } else {
      this.selectedRequirement = null;
      this.isRequired = false;
      this.dataIndex = null;
    }

    if (next) {
      window.scroll(0, 0);
    }
    // if (!this.isEvaluating) {
    // }
  }

  public automaticUpdate() {
    if (!this.reloading) {
      if (!this.data[this.dataIndex].updating) {
        if (this.data[this.dataIndex].type) {
          if (
            this.data[this.dataIndex].type == 1 ||
            this.data[this.dataIndex].type == 5
          ) {
            if (this.data[this.dataIndex].desc1) {
              if (this.data[this.dataIndex].desc1 != "") {
                this.createEvaluation();
              } else {
                Alert.buildErrorAlert(
                  this.translate.instant("evaluations.requirement.empty", {
                    number: this.selectedRequirement.data.chapter.number,
                  })
                );
              }
            } else {
              Alert.buildErrorAlert(
                this.translate.instant("evaluations.requirement.empty", {
                  number: this.selectedRequirement.data.chapter.number,
                })
              );
            }
          }
          if (
            this.data[this.dataIndex].type == 2 ||
            this.data[this.dataIndex].type == 3 ||
            this.data[this.dataIndex].type == 4
          ) {
            if (this.data[this.dataIndex].desc2) {
              if (this.data[this.dataIndex].desc2 != "") {
                this.createEvaluation();
              } else {
                Alert.buildErrorAlert(
                  this.translate.instant("evaluations.requirement.empty", {
                    number: this.selectedRequirement.data.chapter.number,
                  })
                );
              }
            } else {
              Alert.buildErrorAlert(
                this.translate.instant("evaluations.requirement.empty", {
                  number: this.selectedRequirement.data.chapter.number,
                })
              );
            }
          }

          // } else {
          //   Alert.buildErrorAlert(this.translate.instant("evaluations.requirement.evaluating",
          //   {number: this.selectedRequirement.data.chapter.number}))
        }
      } else {
        Alert.buildErrorAlert(
          this.translate.instant("evaluations.process.reloading")
        );
      }
    }
  }

  public checkForChildren() {
    this.filteredRequirements.forEach(requirement => {
      if (requirement.data.chapter.conformityDependency) {
        const _id = requirement.data.chapter.conformityDependency.fatherId.toString();
        const parent = this.filteredRequirements.find(i => i.data.chapter.id === parseInt(_id));
        console.log('>>>',parent, _id, this.filteredRequirements);
        requirement.evaluation = parent && parent.evaluation && parent.evaluation.resultType.id == 2 ? parent.evaluation : null;
        requirement.data.chapter.conformityDependency.evaluationFather = parent && parent.evaluation && parent.evaluation.resultType.id == 2 ? parent.evaluation : null;
      }
    })
  }

  public async getData(
    resetRequirement: boolean = false,
    reload: boolean = false
  ) {
    const [evaluationSummary, reportTypes] = await Promise.all([
      this.sieniService
        .getEvaluationSummary(
          this.evaluationInfo.id,
          this.chapterId,
          this.indexId,
          this.itemId
        )
        .toPromise<any>(),
      /* Condificiona a que si el getData es para actualizar los requerimientos dependientes no se vuellva a pedir los tipos de reporte */
      !reload
        ? this.sieniService.getReportTypes().toPromise<any>()
        : new Promise((resolve) => resolve(this.reportTypes)),
    ]).catch((err) => [null, null]);

    // console.log("entre");
    // console.log(reload);

    if (!reportTypes && !evaluationSummary) {
      console.log("Ocurrio un error al cargar la evaluacion");
    }
    if (reportTypes) {
      this.reportTypes = reportTypes;
    } else {
      if (resetRequirement) {
        this.reloading = false;
        Alert.buildErrorAlert(
          this.translate.instant("evaluations.process.reloadError")
        );
      }
    }

    if (evaluationSummary) {
      this.requirements =
        (evaluationSummary.data && evaluationSummary.data.length > 0)
          ? evaluationSummary.data.map(
              (requirement) => new MRequirement(requirement)
            )
          : [];

      console.log("REQ", JSON.stringify(this.requirements), evaluationSummary);
      var format = "dd-MM-yyyy HH:mm:ss";

      for (let i = 0; i < this.requirements.length; i++) {
        if (this.requirements[i].lastEvaluation) {
          this.requirements[i].lastEvaluation.updatedAt = moment
            .utc(
              this.requirements[i].lastEvaluation.updatedAt,
              "YYYY-MM-DD HH:mm:ss"
            )
            .local()
            .format("DD/MM/YYYY HH:mm:ss");
        }
      }
      this.filteredRequirements = this.requirements;
      this.checkForChildren();

      if (!reload) {
        this.selectedRequirement = this.requirements[0];
      } else {
        this.createData();
      }

      // console.log(this.numbers)
      /* Varifica que el requerimiento seleccionado sea obligatorio o no */
      if (
        this.selectedRequirement.data.chapter.aplicabilityDependency ||
        this.selectedRequirement.data.chapter.conformityDependency
      ) {
        this.isRequired = true;
      } else {
        this.isRequired = false;
      }

      /* Hacer esto cuando no sea una recarga por cambio en los requerimientos, es decir, cuando se ejecuta
      por primera vez el component */
      if (!reload) {
        if (resetRequirement) {
          this.reloading = false;
          Alert.buildSuccessAlert(
            this.translate.instant("evaluations.process.reload")
          );
          this.selectedRequirement = null;
          this.isRequired = false;
          this.setRequirement(this.requirements[0]);
        } else {
          let str = this.requirements[0].data.chapter.number.substr(
            0,
            this.requirements[0].data.chapter.number.lastIndexOf(".")
          );
          this.generateCrumb(str);
          this.createData();
          if (this.idService.getVersionId() === this.versionId) {
            this.selectedProcess = this.idService.getProcessId();
            this.filteredRequirements = [];
            this.setFilteredRequirements();
            this.getCurrentDataIndex();
          } else {
            this.idService.reset();
            this.idService.setVersionId(this.versionId);
          }
        }
      }
    }

    // this.sieniService
    //   .getEvaluationSummary(
    //     this.evaluationInfo.id,
    //     this.chapterId,
    //     this.indexId,
    //     this.itemId
    //   )
    //   .pipe(takeUntil(this.ngUnsubscribe))
    //   .subscribe(
    //     ({ data }: any) => {
    //       // console.log(data)
    //       this.sieniService
    //         .getReportTypes()
    //         .pipe(takeUntil(this.ngUnsubscribe))
    //         .subscribe(res => {
    //           this.reportTypes = res;
    //           this.requirements = [];
    //           let reqs: MRequirement[] = [];
    //           for (let i = 0; i < data.length; i++) {
    //             this.requirements.push(new MRequirement(data[i]));
    //             reqs.push(new MRequirement(data[i]));
    //           }
    //           // console.log(data);
    //           // console.log(this.requirements);
    //           this.filteredRequirements = this.requirements;
    //           this.selectedRequirement = this.requirements[0];
    //           if (
    //             this.selectedRequirement.data.chapter.aplicabilityDependency ||
    //             this.selectedRequirement.data.chapter.conformityDependency
    //           ) {
    //             this.isRequired = true;
    //           } else {
    //             this.isRequired = false;
    //           }

    //           // this.formControls.type.setValue('0')
    //           // console.log(this.formControls)
    //           // console.log(this.form)

    // if (reloaded) {
    //   this.reloading = false;
    //   Alert.buildSuccessAlert(
    //     this.translate.instant("evaluations.process.reload")
    //   );
    //   this.selectedRequirement = null;
    //   this.isRequired = false;
    //   this.setRequirement(this.requirements[0]);
    // } else {
    //   let str = this.requirements[0].data.chapter.number.substr(
    //     0,
    //     this.requirements[0].data.chapter.number.lastIndexOf(".")
    //   );
    //   this.generateCrumb(str);
    //   this.createData();
    //   if (this.idService.getVersionId() === this.versionId) {
    //     this.selectedProcess = this.idService.getProcessId();
    //     this.filteredRequirements = [];
    //     this.setFilteredRequirements();
    //     this.getCurrentDataIndex();
    //   } else {
    //     this.idService.reset();
    //     this.idService.setVersionId(this.versionId);
    //   }
    // }
    //         });
    //     },
    //     err => {
    //       if (reloaded) {
    //         this.reloading = false;
    //         Alert.buildErrorAlert(
    //           this.translate.instant("evaluations.process.reloadError")
    //         );
    //       }
    //     }
    //   );
  }

  private getEvaluationStructure(reloaded: boolean = false) {
    this.sieniService
      .getEvaluationStructure(
        this.moduleId,
        this.versionId,
        this.chapterId,
        this.indexId,
        this.itemId
      )
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        ({ data }: any) => {
          this.requirements = [];
          data.forEach((element) => {
            this.requirements.push(this.pushRequirement(element));
          });

          this.filteredRequirements = this.requirements;
          this.selectedRequirement = this.requirements[0];
          if (
            this.validateRequirementAplicability() ||
            this.validateRequirementConformity()
          ) {
            this.isRequired = true;
          } else {
            this.isRequired = false;
          }

          this.idService.setVersionId(this.versionId);

          // console.log(this.requirements)

          if (reloaded) {
            this.reloading = false;
            Alert.buildSuccessAlert(
              this.translate.instant("evaluations.process.reload")
            );
            this.selectedRequirement = null;
            this.isRequired = false;
            this.setRequirement(this.requirements[0]);
          } else {
            let str = this.requirements[0].data.chapter.number.substr(
              0,
              this.requirements[0].data.chapter.number.lastIndexOf(".")
            );
            this.generateCrumb(str);
            this.createData();
            if (this.idService.getVersionId() === this.versionId) {
              this.selectedProcess = this.idService.getProcessId();
              this.filteredRequirements = [];
              this.setFilteredRequirements();
              this.getCurrentDataIndex();
            } else {
              this.idService.reset();
              this.idService.setVersionId(this.versionId);
            }
          }
          // console.log(this.chapters)
        },
        (err) => {
          if (reloaded) {
            this.reloading = false;
            Alert.buildErrorAlert(
              this.translate.instant("evaluations.process.reloadError")
            );
          }
        }
      );
  }

  private createData() {
    // console.log(this.requirements)
    this.data = [];
    this.requirements.forEach((req) => {
      if (req.evaluation) {
        this.data.push({
          id: req.data.chapter.id,
          desc1: req.evaluation.description1 ? req.evaluation.description1 : "",
          desc2: req.evaluation.description2 ? req.evaluation.description2 : "",
          files: [],
          type: req.evaluation.resultType.id,
          updating: false,
          changed: false,
        });
      } else {
        this.data.push({
          id: req.data.chapter.id,
          desc1: null,
          desc2: null,
          files: [],
          type: null,
          updating: false,
          changed: false,
        });
      }
    });
    // console.log(this.data)
  }

  private pushRequirement(element): MRequirement {
    return new MRequirement({
      req_activos: "0",
      apartado: {
        descripcion: element.descripcion,
        id: element.id,
        ayuda: element.ayuda,
        numero: element.numero,
        titulo: element.titulo,
        dependencia_aplicabilidad: element.dependencia_aplicabilidad,
        dependencia_conformidad: element.dependencia_conformidad,
      },
      req_conformes: "0",
      req_evaluados: "0",
      req_no_conformes: "0",
      req_no_evaluados: "0",
      evaluacion: null,
      procesos: element.procesos,
    });
  }

  private generateCrumb(string: string) {
    this.crumbs.push({
      address: "/sieni",
      name:
        this.translate.instant("breadCrumbs.organization") +
        ": " +
        this.org.name,
    });

    this.crumbs.push({
      address:
        "/sieni/evaluations/" + this.moduleId + "/version/" + this.versionId,
      name: this.evaluation.module.name + ":" + this.evaluation.version,
    });

    let cont: number = 1;
    this.numbers.push(string);

    while (string.lastIndexOf(".") > 0) {
      cont++;
      string = string.substr(0, string.lastIndexOf("."));
      this.numbers.unshift(string);
    }

    for (let i = 0; i < cont; i++) {
      switch (i) {
        case 0:
          this.crumbs.push({
            address:
              "/sieni/evaluations/" +
              this.moduleId +
              "/version/" +
              this.versionId +
              "/chapter/" +
              this.chapterId,
            name:
              this.translate.instant("evaluations.chapter.title") +
              " " +
              this.numbers[i],
          });
          break;

        case 1:
          this.crumbs.push({
            address:
              "/sieni/evaluations/" +
              this.moduleId +
              "/version/" +
              this.versionId +
              "/chapter/" +
              this.chapterId +
              "/index/" +
              this.indexId,
            name:
              this.translate.instant("evaluations.chapter.index.singular") +
              " " +
              this.numbers[i],
          });
          break;

        case 2:
          this.crumbs.push({
            address:
              "/sieni/evaluations/" +
              this.moduleId +
              "/version/" +
              this.versionId +
              "/chapter/" +
              this.chapterId +
              "/index/" +
              this.indexId +
              "/item/" +
              this.itemId,
            name:
              this.translate.instant("evaluations.chapter.item") +
              " " +
              this.numbers[i],
          });
          break;
      }
    }
  }

  public onFileChange(event) {
    this.data[this.dataIndex].changed = true;
    for (let i = 0; i < event.target.files.length; i++) {
      this.data[this.dataIndex].files.push(event.target.files[i]);
    }
  }

  public removeFile(index: number) {
    if (!this.data[this.dataIndex].updating) {
      if (
        !this.selectedRequirement.data.chapter &&
        !this.selectedRequirement.data.chapter.aplicabilityDependency
      ) {
        this.data[this.dataIndex].files.splice(index, 1);
      }
    }
  }

  public setFilteredRequirements() {
    this.idService.setProcessId(this.selectedProcess);
    if (this.selectedProcess > 0) {
      this.filteredRequirements = [];
      for (let i = 0; i < this.requirements.length; i++) {
        for (let j = 0; j < this.requirements[i].data.processes.length; j++) {
          if (
            this.requirements[i].data.processes[j].id == this.selectedProcess
          ) {
            this.filteredRequirements.push(this.requirements[i]);
          }
        }
      }
      if (this.filteredRequirements.length > 0) {
        this.checkFilteredRequirements();
      } else {
        this.setRequirement(null);
      }
    } else {
      // console.log("Nani?")
      this.filteredRequirements = this.requirements;
      if (this.filteredRequirements.length > 0) {
        this.checkFilteredRequirements();
      } else {
        this.setRequirement(null);
      }
    }
  }

  public checkFilteredRequirements() {
    let keep: boolean = false;
    if (this.selectedRequirement) {
      for (let i = 0; i < this.filteredRequirements.length; i++) {
        // console.log(this.filteredRequirements[i].data.chapter.id === this.selectedRequirement.data.chapter.id, "Comparison")
        if (
          this.filteredRequirements[i].data.chapter.id ===
          this.selectedRequirement.data.chapter.id
        ) {
          keep = true;
          break;
        }
      }
    }
    if (!keep) {
      if (this.filteredRequirements.length > 0) {
        this.setRequirement(this.filteredRequirements[0]);
      } else {
        this.setRequirement(null);
      }
    }
  }

  private getCurrentDataIndex() {
    if (this.selectedRequirement) {
      for (let i = 0; i < this.requirements.length; i++) {
        if (
          this.requirements[i].data.chapter.id ===
          this.selectedRequirement.data.chapter.id
        ) {
          this.dataIndex = i;
          break;
        }
      }
    } else {
      this.dataIndex = 0;
    }
  }

  public setDescriptionTitles(type: string) {
    switch (type) {
      case "1":
        this.desc1 = "evaluations.requirement.data.conformity";
        this.desc2 = null;
        break;
      case "2":
        this.desc1 = "evaluations.requirement.data.conformity";
        this.desc2 = "evaluations.requirement.data.nonConformity";
        break;
      case "3":
        this.desc1 = "evaluations.requirement.data.conformity";
        this.desc2 = "evaluations.requirement.type.observation";
        break;
      case "4":
        this.desc1 = "evaluations.requirement.data.conformity";
        this.desc2 = "evaluations.requirement.type.upgradeChance";
        break;
      case "5":
        this.desc1 = "evaluations.requirement.type.notApplyJustification";
        this.desc2 = null;
        break;
      default:
        this.desc1 = null;
        this.desc2 = null;
        break;
    }
  }

  public convertEvidence(evidence: Evidence[]) {
    let names: string[] = [];
    const index: number = this.dataIndex;
    for (let i = 0; i < this.data[this.dataIndex].files.length; i++) {
      let r = new FileReader();
      r.onload = (e: any) => {
        evidence.push({
          base64: e.target.result,
          name: names[i],
        });
        if (this.data[this.dataIndex].files.length === evidence.length) {
          // console.log(evidence)
          for (let j = 0; j < evidence.length; j++) {
            evidence[j].id = null;
            evidence[j].base64 = evidence[j].base64.substr(
              evidence[j].base64.indexOf(",") + 1
            );
          }

          if (this.selectedRequirement.evaluation) {
            this.updateEvidence(evidence, index);
          } else {
            this.postEvaluation(evidence, index);
          }
        }
      };
      names.push(this.data[this.dataIndex].files[i].name);
      r.readAsDataURL(this.data[this.dataIndex].files[i]);
    }
  }

  public async createEvaluation() {
    if (!this.reloading) {
      if (!this.data[this.dataIndex].updating) {
        if (this.data[this.dataIndex].type) {
          if (
            this.data[this.dataIndex].type == 1 ||
            this.data[this.dataIndex].type == 5
          ) {
            if (this.data[this.dataIndex].desc1) {
              if (this.data[this.dataIndex].desc1 != "") {
                this.isEvaluating = true;
                this.data[this.dataIndex].updating = true;
                // console.log(this.data[this.dataIndex].files)
                if (this.data[this.dataIndex].files.length > 0) {
                  // }
                  this.convertEvidence([]);
                } else {
                  if (this.selectedRequirement.evaluation) {
                    console.log('>>updateEvaluation')
                    await this.updateEvaluation(this.dataIndex);
                  } else {
                    console.log('>>postEvaluation')
                    await this.postEvaluation([], this.dataIndex);
                  }
                }
              } else {
                Alert.buildErrorAlert(
                  this.translate.instant("evaluations.requirement.empty", {
                    number: this.selectedRequirement.data.chapter.number,
                  })
                );
              }
            } else {
              Alert.buildErrorAlert(
                this.translate.instant("evaluations.requirement.empty", {
                  number: this.selectedRequirement.data.chapter.number,
                })
              );
            }
          }
          if (
            this.data[this.dataIndex].type == 2 ||
            this.data[this.dataIndex].type == 3 ||
            this.data[this.dataIndex].type == 4
          ) {
            if (this.data[this.dataIndex].desc2) {
              if (this.data[this.dataIndex].desc2 != "") {
                this.isEvaluating = true;
                this.data[this.dataIndex].updating = true;
                // console.log(this.data[this.dataIndex].files)
                if (this.data[this.dataIndex].files.length > 0) {
                  // }
                  this.convertEvidence([]);
                } else {
                  if (this.selectedRequirement.evaluation) {
                    await this.updateEvaluation(this.dataIndex);
                  } else {
                    await this.postEvaluation([], this.dataIndex);
                  }
                }
              } else {
                Alert.buildErrorAlert(
                  this.translate.instant("evaluations.requirement.empty", {
                    number: this.selectedRequirement.data.chapter.number,
                  })
                );
              }
            } else {
              Alert.buildErrorAlert(
                this.translate.instant("evaluations.requirement.empty", {
                  number: this.selectedRequirement.data.chapter.number,
                })
              );
            }
          }
        }
      }
    }

    // const requirements = this.requirements;

    // requirements.forEach(async requirement => {
    //   console.log('entre')
    //   if (
    //     requirement.data.chapter.aplicabilityDependency &&
    //     requirement.data.chapter.aplicabilityDependency.fatherId ==
    //       this.data[this.dataIndex].id
    //   ) {
    //     this.sieniService
    //       .getRequirement(
    //         this.evaluationInfo.id,
    //         this.chapterId,
    //         this.indexId,
    //         this.itemId,
    //         this.data[this.dataIndex].id
    //       )
    //       .pipe(map((resp: any) => resp.data as MRequirementEvaluation))
    //       .toPromise()
    //       .then(resp => console.log(resp))
    //       .catch(err => console.warn(err));
    //   }
    // });

    // this.sieniService
    //   .getRequirement(
    //     this.evaluationInfo.id,
    //     this.chapterId,
    //     this.indexId,
    //     this.itemId,
    //     this.data[this.dataIndex].id
    //   )
    //   .subscribe((res: any) => {
    //     // console.log(res)
    //     const reloadRequerement = new MRequirement(res.data);
    //     console.log(reloadRequerement);

    //     this.requirements = this.requirements.map(requerement => {
    //       if (
    //         requerement.data.chapter.id == reloadRequerement.data.chapter.id
    //       ) {
    //         return reloadRequerement;
    //       }

    //       return requerement;
    //     });
    //   });

    // this.getData(true);
  }

  public async postEvaluation(evidence, index: number) {
    // console.log(evidence)
    const reqId: number = this.selectedRequirement.data.chapter.id;
    await this.sieniService
      .createRequirementEvaluation(
        this.evaluationInfo.id,
        reqId,
        this.data[index].type,
        this.data[index].desc1,
        this.desc2 ? this.data[index].desc2 : null,
        evidence
      )
      .pipe(takeUntil(this.ngUnsubscribe))
      .toPromise()
      .then(
        async ({ data }: any) => {
          this.isEvaluating = false;
          for (let i = 0; i < this.requirements.length; i++) {
            if (this.requirements[i].data.chapter.id === reqId) {
              this.requirements[i].evaluation = new MRequirementEvaluation({
                id: data.id,
                created_at: data.ultima_actualizacion,
                updated_at: data.ultima_actualizacion,
                tipo_resultado_id: data.tipo_resultado.id,
                descripcion1: data.descripcion1,
                descripcion2: data.descripcion2,
                evidencias_evaluaciones: data.evidencias_evaluaciones,
                tipo_resultado: data.tipo_resultado,
              });
              this.data[index].files = [];
              this.setFilteredRequirements();
              break;
            }
          }
          await this.getData(false, true);

          /* muestra un mensaje si ya se evaluaron todos los requerimientos */

          // await this.reloadDataRequirementsDependency(reqId);

          this.data[index].updating = false;
          this.data[index].changed = false;

          let isCompleteEvaluation: boolean =
            this.requirements.filter((requeriment) => !requeriment.evaluation)
              .length === 0;

          if (isCompleteEvaluation) {
            Alert.buildSuccessAlert(
              this.translate.instant(
                "evaluations.requirement.alert.successComplete",
                {
                  item: this.requirements[0].data.chapter.number.substr(
                    0,
                    this.requirements[0].data.chapter.number.lastIndexOf(".")
                  ),
                }
              )
            );
          } else {
            Alert.buildSuccessAlert(
              this.translate.instant("evaluations.requirement.alert.success", {
                number: this.requirements[index].data.chapter.number,
              })
            );
          }
        },
        (err) => {
          this.isEvaluating = false;
          this.data[index].updating = false;
          Alert.buildErrorAlert(
            this.translate.instant("evaluations.requirement.alert.error", {
              number: this.requirements[index].data.chapter.number,
            })
          );
        }
      );
  }

  public async updateEvaluation(index: number) {
    const reqId = this.selectedRequirement.data.chapter.id;
    await this.sieniService
      .updateRequirementEvaluation(
        this.evaluationInfo.id,
        this.selectedRequirement.evaluation.id,
        reqId,
        this.data[index].type,
        this.data[index].desc1,
        this.desc2 ? this.data[index].desc2 : null
      )
      .pipe(takeUntil(this.ngUnsubscribe))
      .toPromise()
      .then(
        async ({ data }: any) => {
          for (let i = 0; i < this.requirements.length; i++) {
            if (this.requirements[i].data.chapter.id === reqId) {
              this.requirements[i].evaluation.description1 = data.descripcion1;
              this.requirements[i].evaluation.description2 = data.descripcion2;
              this.requirements[i].evaluation.typeResultId =
                data.tipo_resultado.id;
              this.requirements[i].evaluation.updatedAt =
                data.ultima_actualizacion;
              this.requirements[i].evaluation.evidence = [];
              this.requirements[i].evaluation.resultType.id =
                data.tipo_resultado.id;
              this.requirements[i].evaluation.resultType.name =
                data.tipo_resultado.nombre;
              data.evidencias_evaluaciones.forEach((e) => {
                this.requirements[i].evaluation.evidence.push(
                  new MEvaluationEvidence(e)
                );
              });
              this.data[index].files = [];
              this.data[index].changed = false;
              // console.log(this.selectedProcess)
              this.setFilteredRequirements();
              // this.setRequirement(this.selectedRequirement)
              break;
            }
          }

          // console.log(reqId);
          // console.log(this.data[index]);

          await this.getData(false, true);
          //  this.reloadDataRequirementsDependency(reqId);

          this.isEvaluating = false;
          this.data[index].updating = false;
          this.data[index].changed = false;
          let isCompleteEvaluation: boolean =
            this.requirements.filter((requeriment) => !requeriment.evaluation)
              .length === 0;

          if (isCompleteEvaluation) {
            Alert.buildSuccessAlert(
              this.translate.instant(
                "evaluations.requirement.alert.successComplete",
                {
                  item: this.requirements[0].data.chapter.number.substr(
                    0,
                    this.requirements[0].data.chapter.number.lastIndexOf(".")
                  ),
                }
              )
            );
          } else {
            Alert.buildSuccessAlert(
              this.translate.instant("evaluations.update.alert.updateSuccess", {
                number: this.requirements[index].data.chapter.number,
              })
            );
          }
        },
        (err) => {
          this.data[index].updating = false;
          this.isEvaluating = false;
          Alert.buildErrorAlert(
            this.translate.instant("evaluations.update.alert.updateError", {
              number: this.requirements[index].data.chapter.number,
            })
          );
        }
      );
  }

  public updateEvidence(evidence: Evidence[], index: number) {

    this.sieniService
      .updateRequiremtenEvaluationEvidence(
        this.evaluationInfo.id,
        this.selectedRequirement.data.chapter.id,
        evidence
      )
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (res) => {
          this.updateEvaluation(index);
        },
        (err) => {
          this.isEvaluating = false;
          this.data[index].updating = false;
          Alert.buildErrorAlert(
            this.translate.instant("evaluations.update.alert.evidenceError")
          );
        }
      );
  }

  public cleanEvidence(data) {
    // console.log(data)
    for (let i = 0; i < this.requirements.length; i++) {
      if (data.reqId === this.requirements[i].data.chapter.id) {
        // console.log(this.requirements[i])
        for (
          let j = 0;
          j < this.requirements[i].evaluation.evidence.length;
          j++
        ) {
          if (data.id === this.requirements[i].evaluation.evidence[j].id) {
            // console.log(this.requirements[i].evaluation.evidence[j])
            this.requirements[i].evaluation.evidence.splice(j, 1);
            this.setRequirement(this.selectedRequirement);
            break;
          }
        }
      }
    }
  }

  public resetData() {
    this.data[this.dataIndex].desc1 = "";
    this.data[this.dataIndex].desc2 = "";
    this.data[this.dataIndex].files = [];
    this.data[this.dataIndex].type = null;
  }

  public setTakers(content) {
    this.modalService.open(content, { centered: true }).result.then(
      (res) => {
        Alert.buildSuccessAlert(
          this.translate.instant("evaluations.takers.update")
        );
      },
      (err) => {}
    );
  }

  public filteredPosition(id: number, next: boolean = true) {
    for (let i = 0; i < this.filteredRequirements.length; i++) {
      if (this.filteredRequirements[i].data.chapter.id === id) {
        if (next) {
          return i + 1;
        } else {
          return i - 1;
        }
      }
    }
  }

  public reloadProcesses() {
    let reload = true;
    for (let i = 0; i < this.data.length; i++) {
      if (this.data[i].updating) {
        reload = false;
        break;
      }
    }
    if (reload) {
      this.reloading = true;
      // debugger
      this.sieniService
        .getProcesses()
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(
          ({ data }: any) => {
            // console.log(data)
            this.processes = [];
            // data.data.foreach(p => {
            //   this.processes.push(new MProcess(p))
            // })
            for (let i = 0; i < data.length; i++) {
              this.processes.push(new MProcess(data[i]));
            }
            if (this.evaluationInfo) {
              this.getData(true);
            } else {
              this.getEvaluationStructure(true);
            }
            // this.reloading = false;
          },
          (err) => {
            // console.log(err)
            this.reloading = false;
            Alert.buildErrorAlert(
              this.translate.instant("evaluations.process.reloadError")
            );
          }
        );
    } else
      Alert.buildErrorAlert(this.translate.instant("evaluations.process.busy"));
  }

  public registerNonConformity() {
    const user = this.sieniService.user;
    user.children = [];
    // console.log({
    //   user,
    //   organization: this.org
    // })
    const userData = btoa(
      unescape(
        encodeURIComponent(
          JSON.stringify({
            user,
            organization: this.org,
          })
        )
      )
    );
    console.log({
      data: this.selectedRequirement,
      versionId: this.versionId,
      module: this.evaluation.module,
    });
    const data = btoa(
      unescape(
        encodeURIComponent(
          JSON.stringify({
            data: this.selectedRequirement,
            versionId: this.versionId,
            module: this.evaluation.module,
          })
        )
      )
    );
    // console.log(data)
    // console.log( "http://localhost:5000/nc/#/auth-gnc?code=" +
    // userData +
    // "&data=" +
    // data)
    window.open(
      environment.gnc + "/#/auth-gnc?code=" + userData + "&data=" + data,
      "_blank"
    );
  }

  public openHelpRequirement(requirement: MRequirement) {
    // console.log(requirement.data.chapter);
    const win = window.open(
      "",
      // "https://google.com",
      "SIENI",
      "resizable=yes,toolbar=no,location=no,directories=no,status=no,menubar=no",
      true
    );
    win.document.body.innerHTML = getBodyHelp(
      requirement.data.chapter.number,
      requirement.data.chapter.help
    );
    win.resizeTo(screen.availWidth, screen.availHeight);
    win.moveTo(0, 0);
  }

  public validateRequirementAplicability() {
    return (
      this.selectedRequirement.data.chapter.aplicabilityDependency &&
      this.selectedRequirement.data.chapter.aplicabilityDependency
        .evaluationFather &&
      this.selectedRequirement.data.chapter.aplicabilityDependency
        .evaluationFather.resultType.id === 5
    );
  }

  public validateRequirementConformity() {
    return (
      this.selectedRequirement.data.chapter.conformityDependency &&
      this.selectedRequirement.data.chapter.conformityDependency
        .evaluationFather &&
      this.selectedRequirement.data.chapter.conformityDependency
        .evaluationFather.resultType.id === 2
    );
  }
}
